import { CLEAR_CUSTOMER_INFORMATION } from "../../constants";
import { setActiveFormInLocalStorage } from "../setActiveFormInLocalStorage/setActiveFormInLocalStorage";

export const clearCustomerInformationFromLocalStorage = () => {
  // clear customer data from localStorage and sessionStorage
  window.localStorage.removeItem("customerInformation");
  window.localStorage.removeItem("eInvoiceData");
  window.sessionStorage.removeItem("customerCitizenshipCountry");
  window.sessionStorage.removeItem("registryTermsAccepted");
  window.sessionStorage.removeItem("keySystemTermsAccepted");

  setActiveFormInLocalStorage("customer");

  return {
    type: CLEAR_CUSTOMER_INFORMATION,
  };
};
